'use strict';

import { State } from 'angular-store';
import { Controller } from '@/decorators/ngCtrl';

@Controller
class Error404View {
  constructor() {
    'ngInject';
  }
}

export default Error404View;
